"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initCentrifuge = initCentrifuge;

var _centrifuge = require("../selectors/centrifuge");

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

var actionSetConnectionData = function actionSetConnectionData(data) {
  return {
    payload: data,
    type: 'SET_CONNECTION_DATA'
  };
};

var actionSetConnectionInProcess = function actionSetConnectionInProcess(inProcess) {
  return {
    payload: inProcess,
    type: 'SET_CONNECTION_IN_PROCESS'
  };
};

var actionSetIsConnected = function actionSetIsConnected(isConnected) {
  return {
    payload: isConnected,
    type: 'SET_IS_CONNECTED'
  };
};

function getConnectionData() {
  return (
    /*#__PURE__*/
    function () {
      var _ref2 = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee(dispatch, getState, _ref) {
        var centrifugeApi, _ref3, data, errors;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                centrifugeApi = _ref.centrifugeApi;
                _context.next = 3;
                return centrifugeApi.getConnectionData();

              case 3:
                _ref3 = _context.sent;
                data = _ref3.data;
                errors = _ref3.errors;

                if (errors) {
                  _context.next = 8;
                  break;
                }

                return _context.abrupt("return", dispatch(actionSetConnectionData(data)));

              case 8:
                return _context.abrupt("return", errors);

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x, _x2, _x3) {
        return _ref2.apply(this, arguments);
      };
    }()
  );
}

function connectCentrifuge(options) {
  return (
    /*#__PURE__*/
    function () {
      var _ref5 = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee2(dispatch, getState, _ref4) {
        var centrifugeService, connectionData;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                centrifugeService = _ref4.centrifugeService;
                dispatch(actionSetConnectionInProcess(true));
                _context2.next = 4;
                return dispatch(getConnectionData());

              case 4:
                connectionData = (0, _centrifuge.selectConnectionData)(getState());

                if (connectionData) {
                  centrifugeService.connect({
                    connectionData: connectionData,
                    onConnect: function onConnect() {
                      dispatch(actionSetConnectionInProcess(false));
                      dispatch(actionSetIsConnected(true));
                    },
                    onDisconnect: function onDisconnect() {
                      dispatch(actionSetIsConnected(false));
                    },
                    options: options
                  });
                }

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function (_x4, _x5, _x6) {
        return _ref5.apply(this, arguments);
      };
    }()
  );
}

function initCentrifuge(options) {
  return (
    /*#__PURE__*/
    function () {
      var _ref6 = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee3(dispatch, getState) {
        var state, isConnected, inProcess;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                state = getState();
                isConnected = (0, _centrifuge.selectIsConnected)(state);
                inProcess = (0, _centrifuge.selectConnectionInProcess)(state);

                if (!isConnected && !inProcess) {
                  dispatch(connectCentrifuge(options));
                }

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      return function (_x7, _x8) {
        return _ref6.apply(this, arguments);
      };
    }()
  );
}